var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.507812 2.31305V8.69305C0.507812 9.99972 1.92781 10.8197 3.06115 10.1664L5.82781 8.57305L8.59448 6.97305C9.72781 6.31972 9.72781 4.68638 8.59448 4.03305L5.82781 2.43305L3.06115 0.839714C1.92781 0.18638 0.507812 0.999713 0.507812 2.31305ZM11.4918 10.1197C11.2185 10.1197 10.9918 9.89305 10.9918 9.61972V1.37971C10.9918 1.10638 11.2185 0.879714 11.4918 0.879714C11.7651 0.879714 11.9918 1.10638 11.9918 1.37971V9.61972C11.9918 9.89305 11.7718 10.1197 11.4918 10.1197Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.fa9185e6cb020be7c27a8afcc38ab5aa.svg";
export { ForwardRef as ReactComponent };